import BasicService from "./BasicService";

class AdvanceReportService extends BasicService {
  constructor() {
    super();
  }
  getAdvanceReportList(fromDate, toDate, osId) {
    let url = `/report/collectedPayment`;
    return this.axios
      .get(url, {
        params: {
          fromDate,
          toDate,
          osId
        }
      })
      .then(request => request.data);
  }
  actionAdvancePayment(data, payment) {
    let url = `/report/advancePaid`;
    let obj = {
      data,
      payment
    };
    return this.axios.post(url, obj).then(request => request.data);
  }
  getAdvanceReportById(itemId) {
    let url = `/report/advancePaid`;
    return this.axios
      .get(url, {
        params: {
          itemId: itemId
        }
      })
      .then(response => response.data);
  }
}

const advanceReportService = new AdvanceReportService();
export default advanceReportService;
